import * as microsoftTeams from "@microsoft/teams-js";

export const TEAMS_O365_AUTH_STATE = "goget_teams_o365_auth";
export const TEAMS_MICROSOFT_LOGIN_AUTH_STATE =
  "goget_teams_microsoft_login_auth";
export const TEAMS_MICROSOFT_LOGIN_TOKEN_STORAGE_KEY =
  "goget_teams_microsoft_login_token";
const TEAMS_O365_AUTH_START_PARAM = "teamsO365AuthStart";
const TEAMS_O365_AUTH_URL_PARAM = "authUrl";

const initializeTeamsApp = async () => {
  if (microsoftTeams.app.isInitialized()) {
    return;
  }

  await new Promise<void>((resolve, reject) => {
    const timeout = window.setTimeout(() => {
      reject(new Error("Microsoft Teams SDK initialization timed out."));
    }, 1500);

    microsoftTeams.app
      .initialize()
      .then(() => {
        window.clearTimeout(timeout);
        resolve();
      })
      .catch((error) => {
        window.clearTimeout(timeout);
        reject(error);
      });
  });
};

export const buildTeamsO365AuthStartUrl = (
  dashboardUrl: string,
  authUrl: string
) => {
  const url = new URL(dashboardUrl);

  url.searchParams.set(TEAMS_O365_AUTH_START_PARAM, "1");
  url.searchParams.set(TEAMS_O365_AUTH_URL_PARAM, authUrl);

  return url.toString();
};

export const handleTeamsO365AuthFrame = async () => {
  const searchParams = new URLSearchParams(window.location.search);

  if (searchParams.get(TEAMS_O365_AUTH_START_PARAM) === "1") {
    const authUrl = searchParams.get(TEAMS_O365_AUTH_URL_PARAM);

    if (!authUrl) {
      return false;
    }

    try {
      await initializeTeamsApp();

      if (
        microsoftTeams.app.getFrameContext() !==
        microsoftTeams.FrameContexts.authentication
      ) {
        return false;
      }

      window.location.replace(authUrl);
      return true;
    } catch (error) {
      return false;
    }
  }

  const hashParams = new URLSearchParams(window.location.hash.replace(/^#/, ""));
  const state = hashParams.get("state");

  if (state === TEAMS_MICROSOFT_LOGIN_AUTH_STATE) {
    try {
      await initializeTeamsApp();

      if (
        microsoftTeams.app.getFrameContext() !==
        microsoftTeams.FrameContexts.authentication
      ) {
        return false;
      }

      const authError = hashParams.get("error_description");

      if (authError) {
        microsoftTeams.authentication.notifyFailure(authError);
        return true;
      }

      const accessToken = hashParams.get("access_token");

      if (!accessToken) {
        microsoftTeams.authentication.notifyFailure(
          "Microsoft authentication did not return an access token."
        );
        return true;
      }

      localStorage.setItem(
        TEAMS_MICROSOFT_LOGIN_TOKEN_STORAGE_KEY,
        accessToken
      );
      microsoftTeams.authentication.notifySuccess(
        TEAMS_MICROSOFT_LOGIN_AUTH_STATE
      );
      return true;
    } catch (error) {
      return false;
    }
  }

  if (
    state !== TEAMS_O365_AUTH_STATE ||
    !hashParams.get("code")
  ) {
    return false;
  }

  try {
    await initializeTeamsApp();

    if (
      microsoftTeams.app.getFrameContext() !==
      microsoftTeams.FrameContexts.authentication
    ) {
      return false;
    }

    microsoftTeams.authentication.notifySuccess(window.location.href);
    return true;
  } catch (error) {
    return false;
  }
};
